import { render, staticRenderFns } from "./ParticipantInternalNoteForm.vue?vue&type=template&id=6c19fc71&scoped=true&"
import script from "./ParticipantInternalNoteForm.vue?vue&type=script&lang=js&"
export * from "./ParticipantInternalNoteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c19fc71",
  null
  
)

export default component.exports